import { frontendURL } from 'dashboard/helper/URLHelper.js';
import KanbanPage from './pages/KanbanPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_view',
    component: KanbanPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
